import React, { useEffect } from 'react';

import withPageComponents from '../../page/components/with-page-components';
import { useUserReceived } from '../../hooks/useUserData';

export default withPageComponents(
    ({ finderResults }) => {
        const { behpDetails = {} } = finderResults || {};
        const { result_id } = behpDetails || {};
        let userReceived = useUserReceived();
        useEffect(() => {
            try {
                if (userReceived) {
                    pagePropertiesData.search = pagePropertiesData.search || {};
                    if (pagePropertiesData.search.BeHPID !== result_id) {
                        pagePropertiesData.search.BeHPID = result_id || 'Not-Found';
                    }
                }
            } catch (e) {}
        }, [result_id, userReceived]);

        return null;
    },
    { components: ['finderResults'] },
);
